import React from "react";
import styles from "./board.module.css";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/footer/footer";
import BoardDirectors from "../../components/board/index";
import Card from "../../components/cardPerson/index";
import tawfikImage from "../../assets/images/boardOfDirectors/Eng_Tawfik.png";
import amrImage from "../../assets/images/boardOfDirectors/Mr_Amr.png";
import walidImage from "../../assets/images/boardOfDirectors/Mr_Walid.png";
import anonymousImage from "../../assets/images/boardOfDirectors/anonymousPerson.png";

const Board = () => {
  const cardData = [
    {
      image: tawfikImage,
      header: "Eng. Tawfik Salah El Din Ahmed Diab",
      paragraph: "Chairman & CEO",
    },
    {
      image: amrImage,
      header: "Mr. Amr Al Badry (ADI)",
      paragraph: "Board Member",
    },
    {
      image: walidImage,
      header: "Mr. Walid El Ogail (ADI)",
      paragraph: "Board Member",
    },
    {
      image: anonymousImage,
      header: "Salah Shafei",
      paragraph: "Pico Investments",
    },
    {
      image: anonymousImage,
      header: "Mr. Sherif Al Akhdar",
      paragraph: "Board Member",
    },
    {
      image: anonymousImage,
      header: "Mrs. Noha Mansour",
      paragraph: "Board Member",
    },
  ];
  return (
    <div>
      {" "}
      <NavBar />
      <BoardDirectors />
      <div className={styles.container}>
        <h2 className={styles.header}>All Members</h2>
        <div className={styles.cardsContainer}>
          {cardData.slice(0, 3).map((card, index) => (
            <Card
              key={index}
              image={card.image}
              header={card.header}
              paragraph={card.paragraph}
              largeCardItem={true}
            />
          ))}
        </div>
        <div className={styles.cardsContainer}>
          {cardData.slice(3).map((card, index) => (
            <Card
              key={index}
              image={card.image}
              header={card.header}
              paragraph={card.paragraph}
              largeCardItem={true}
            />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Board;
